import React from "react";

import SearchableList from "components/SearchableList";
import BlogPostThumbnail from "components/BlogPostThumbnail";
import BlogFeaturedPost from "components/BlogFeaturedPost";
import BlogTopPicks from "components/BlogTopPicks";

import * as styles from "../styles.module.less";

/**
 * @typedef {object} BlogTemplateProps
 * @prop {GatsbyTypes.BlogPostThumbnailFragment[]} blogPosts
 * @prop {readonly GatsbyTypes.BlogPostThumbnailFragment[]} topPicksPosts
 * @prop {GatsbyTypes.FeaturedPostFragment} featuredPost
 * @prop {readonly string[]} tags
 * @prop {object} searchIndex
 * @prop {string} featuredPostLinkButtonText
 * @prop {string} featuredPostLinkButtonIcon
 * @prop {string} topPicksPostsLabelText
 *
 * @param {BlogTemplateProps} props
 */

export function NewsroomTemplate({
  featuredPost,
  topPicksPosts,
  blogPosts,
  searchIndex,
  featuredPostLinkButtonText,
  featuredPostLinkButtonIcon,
  topPicksPostsLabelText,
}) {
  return (
    <>
      {featuredPost && (
        <BlogFeaturedPost
          {...featuredPost.frontmatter}
          path={featuredPost.fields.path}
          excerpt={featuredPost.excerpt}
          linkButtonText={featuredPostLinkButtonText}
          linkButtonIcon={featuredPostLinkButtonIcon}
        />
      )}
      {topPicksPosts && (
        <BlogTopPicks
          labelText={topPicksPostsLabelText}
          posts={topPicksPosts || []}
        />
      )}
      <div className={styles.regularContainer}>
        <SearchableList
          searchConfig={{
            fields: {
              title: { boost: 2, bool: "AND" },
              body: {},
              description: {},
              subtitle: {},
            },
          }}
          dataSource={blogPosts}
          pagination={{
            defaultPageSize: 16,
          }}
          grid={{
            gutter: 32,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 4,
            xxl: 4,
          }}
          renderItem={(post, index) => (
            <BlogPostThumbnail key={`postthumbnail-${index}`} {...post} />
          )}
          index={searchIndex}
        />
      </div>
    </>
  );
}
